import type { FaireProductEntity } from "../../entity_types/product";

export const p_qs8hjcynwh: FaireProductEntity = {
  token: "p_qs8hjcynwh",
  type: "product",
  name: "Foodie Gourmet - Belgian - White Chocolate Curls",
  brandToken: "b_bzxg32q5dk",
  brandName: "Alta Gama Foods",
  imageUrl:
    "https://cdn.faire.com/fastly/bd4fbcc90ee5a22b6075110a9469939be95fc507fd90cfd6955305805ba798da.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9ba1f54801cc3ce7aae4de4401b70994d1675d837d8f16c8526b3a5ecc7cd9ea.png",
    "https://cdn.faire.com/fastly/491b7cd8c9b47b340765130431ce6fb82e2a0654d2e947608faf2f4cd8365a5f.png",
  ],
  priceDollars: 7.21,
  description:
    "Premium Belgian White Chocolate curls, blossoms, shavings. Perfect for lattes, hot chocolate, pies, cakes, cupcakes, donuts and desserts. Available in retail, bulk and foodservice sizes. \n\n\nchefs, catering, bakery, bakers, premium Belgian chocolate, cocao, cakes, decorations, chocolate, curls, shavings, toppers",
  tags: [],
  msrpDollars: 14.41,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:50:17.031Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
